import React, { useState, useEffect } from 'react';
import Logo from '../Logo/Logo';
import {
	NavContainer,
	Nav,
	SubNavMenu,
	SubNavMenuList,
	SubNavMenuListItem
} from '../../components/Navigation/Style';
import { BodyContainer } from '../StyledComponents/StyledComponents';

const Navigation = ({ page, logoColor, alwaysVisible = false }) => {
	const [isVisible, setIsVisible] = useState(alwaysVisible);

	useEffect(() => {
		// Si alwaysVisible es true, no aplicar la lógica de scroll
		if (alwaysVisible) {
			setIsVisible(true);
			return;
		}

		const handleScroll = () => {
			const scrollY = window.scrollY;
			// Mostrar el menú después de hacer scroll de 100px
			if (scrollY > 100) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener('scroll', handleScroll);
		
		// Limpiar el event listener cuando el componente se desmonte
		return () => window.removeEventListener('scroll', handleScroll);
	}, [alwaysVisible]);

	return (
		<nav>
			<NavContainer isVisible={isVisible}>
				<BodyContainer>
					<Nav>
						<Logo color={logoColor} size="36px" />
						<SubNavMenu>
							<SubNavMenuList>
								<SubNavMenuListItem active={page === 'about' ? true : false}><a href="/about">Acerca de</a></SubNavMenuListItem>
								<SubNavMenuListItem active={page === 'contact' ? true : false}><a href="/contact">Contacto</a></SubNavMenuListItem>
							</SubNavMenuList>
						</SubNavMenu>
					</Nav>
				</BodyContainer>
			</NavContainer>
		</nav>
	);
};

export default Navigation;
